import { render, staticRenderFns } from "./techHistory.vue?vue&type=template&id=49d787fc&scoped=true"
import script from "./techHistory.vue?vue&type=script&lang=js"
export * from "./techHistory.vue?vue&type=script&lang=js"
import style0 from "./techHistory.vue?vue&type=style&index=0&id=49d787fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d787fc",
  null
  
)

export default component.exports